module.exports = __webpack_public_path__ + "img/f460de3.jpg";